import React from "react";
import { BidTypeEnum, ListingStatusEnum } from "../../commonEnums";
import { IListing, IListingIssueDetails, INft } from "../../commonTypes";
import AuctionBidCard from "./Auction/AuctionBidCard";
import InstantBidCard from "./InstantBid/InstantBidCard";
import SoldBidCard from "./SoldBid/SoldBidCard";

type Props = {
  listing: IListing;
  openBidModal: () => void;
  nft?: INft;
  issueDetails?: IListingIssueDetails;
};

const BidCard = ({ listing, openBidModal, nft, issueDetails }: Props) => {
  if (
    [
      ListingStatusEnum.minted,
      ListingStatusEnum.sold,
      ListingStatusEnum.minting,
    ].includes(listing.status)
  ) {
    return <SoldBidCard listing={listing} nft={nft} />;
  }

  if (listing.type === BidTypeEnum.bid) {
    return (
      <AuctionBidCard
        listing={listing}
        onClick={openBidModal}
        issueDetails={issueDetails}
      />
    );
  }

  return (
    <InstantBidCard
      listing={listing}
      onClick={openBidModal}
      issueDetails={issueDetails}
    />
  );
};

export default BidCard;
